"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveCompactResultsViewToLocalStorage = exports.prepareMarkersToMarkerInterface = exports.getCompactResultsViewFromLocalStorage = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _localStorageInterface = _interopRequireDefault(require("../../../helpers/localStorageInterface"));
var _config = require("../../../services/config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var prepareMarkersToMarkerInterface = exports.prepareMarkersToMarkerInterface = function prepareMarkersToMarkerInterface(markers) {
  return R.map(function (_ref) {
    var hotelID = _ref.hotelID,
      position = _ref.position,
      offerID = _ref.offerID,
      stars = _ref.stars;
    return {
      hotelID: hotelID,
      offerID: offerID,
      position: position,
      props: {
        stars: stars
      }
    };
  }, markers);
};
var COMPACT_RESULTS_VIEW_STORAGE_KEY = 'COMPACT_RESULTS_VIEW_STORAGE_KEY';
var getCompactResultsViewFromLocalStorage = exports.getCompactResultsViewFromLocalStorage = function getCompactResultsViewFromLocalStorage() {
  return R.call(R.ifElse(Boolean, function (compact) {
    return JSON.parse(compact);
  }, _config.getInitialIsCompactResultsView), _localStorageInterface.default.getItem(COMPACT_RESULTS_VIEW_STORAGE_KEY));
};
var saveCompactResultsViewToLocalStorage = exports.saveCompactResultsViewToLocalStorage = function saveCompactResultsViewToLocalStorage(compact) {
  return _localStorageInterface.default.setItem(COMPACT_RESULTS_VIEW_STORAGE_KEY, compact);
};